import { createSlice } from '@reduxjs/toolkit';
import { approveKycTerms } from '../views/Kyc/KycAgreement/KycAgreement.actions';
import { addKycPersonalDetails } from '../views/Kyc/KycPersonalDetails/KycPersonalDetails.actios';
import { addKycDocument } from '../views/Kyc/KycDocuments/KycDocuments.actions';
import { addKycDocumentImage } from '../views/Kyc/KycDocumentPhotos/KycDocumentPhotos.actions';
import { addKycSelfie } from '../views/Kyc/KycSelfieTIme/KycSelfieTime.actions';

export interface kycInitialStateType {
  loading: boolean;
}

const initialState = {
  loading: false
} as kycInitialStateType;

const kycSlice = createSlice({
  name: 'kyc',
  initialState,
  reducers: {
    // storeRegisterInfo(state, { payload }) {
    //   state.register = payload;
    // },
  },

  extraReducers: (builder) => {
    builder.addCase(approveKycTerms.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(approveKycTerms.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(approveKycTerms.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addKycPersonalDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addKycPersonalDetails.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(addKycPersonalDetails.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addKycDocument.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addKycDocument.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(addKycDocument.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addKycDocumentImage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addKycDocumentImage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(addKycDocumentImage.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addKycSelfie.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addKycSelfie.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(addKycSelfie.rejected, (state) => {
      state.loading = false;
    });
  }
});

// export const { storeRegisterInfo } = kycSlice.actions;

export default kycSlice.reducer;
